import { motion } from "framer-motion";
import { FiUser, FiTrendingUp } from "react-icons/fi";

const AboutCard = ({ icon: Icon, title, content, delay = 0 }) => (
  <motion.div
    initial={{ opacity: 1, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.6, delay }}
    viewport={{ once: true }}
    className="bg-[#1e1e20] backdrop-blur-md border border-white/10 rounded-xl p-6 mb-6 shadow-md hover:shadow-lg transition duration-300 group"
  >
    <div className="flex items-center gap-3 mb-4">
      <div className="p-2 bg-indigo-600/20 rounded-full">
        <Icon className="text-indigo-400 w-5 h-5" />
      </div>
      <h3 className="text-lg sm:text-2xl font-bold text-white">{title}</h3>
    </div>
    <p className="text-sm sm:text-xl text-gray-300 leading-relaxed">
      {content}
    </p>
  </motion.div>
);

const About = () => {
  return (
    <div name="About" className="md:pt-20 w-full h-fit text-white">
      <div className="max-w-screen-lg px-4 pt-12 pb-36 mx-auto flex flex-col justify-center">
        <motion.div
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
          className="pb-8"
        >
          <p className="text-4xl font-bold inline border-b-4 border-gray-400">
            About
          </p>
        </motion.div>

        {/* Cards Section */}
        <div className="grid grid-cols-1 gap-6">
          <AboutCard
            icon={FiUser}
            title="About Me"
            content="I'm Utkarsh Shahare, a Full-Stack Developer and Computer Science (Data Science) student at Shri Ramdeobaba College of Engineering and Management, Nagpur. I specialize in building modern web applications using React, Spring Boot, Java, and REST APIs.

With a strong foundation in software development and problem-solving, I enjoy creating scalable applications that combine clean design with efficient backend architecture. From authentication systems to full-stack financial and management platforms, I love turning complex challenges into practical solutions.

When I'm not coding, you'll find me exploring new technologies, solving programming problems, gaming, or working on projects that help me grow as a developer.
"
            delay={0.1}
          />
          <AboutCard
            icon={FiTrendingUp}
            title="My Journey"
            content="Since completing high school in 2022, I've immersed myself in the tech world — learning through coding projects and continuous exploration. Whether debugging algorithms or building intuitive websites, I stay driven by curiosity and a desire to grow."
            delay={0.2}
          />
        </div>
      </div>
    </div>
  );
};

export default About;
